import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {InductionService} from "../../induction/induction.service";
import {SpecialDayService} from "../special-day.service";
import {SpecialDay} from "../special-day.model";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-view-special-day',
  templateUrl: './view-special-day.component.html',
  styleUrls: ['./view-special-day.component.scss']
})
export class ViewSpecialDayComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  special!: SpecialDay | null;
  isLoading: boolean = true;

  // Track expanded state for each field
  expandedFields: { [key: string]: boolean } = {
    topic: false,
    teachingAid: false,
    observationComment: false,
    suggestions: false
  };

  constructor(
    private route: ActivatedRoute,
    private specialDayService: SpecialDayService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.specialDayService.getDataById(id).pipe(takeUntil(this._destroyed$)).subscribe(data => {
        console.log(data);
        this.special = data ?? null;
        this.isLoading = false;
      });
    }
  }

  extractFileName(url?: string): string {
    if (!url) return '';
    const decoded = decodeURIComponent(url);
    const lastPart = decoded.split('/').pop() || "";
    return lastPart.split('?')[0];
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
